import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";

const useOrderType = () => {
  const { order, configuration } = useSelector((state) => state.yodaOrders);

  const isReorderEnabled = useMemo(() => {
    return !!configuration?.find?.(
      (config) => config?.typeId === 1 && config?.configuration?.length,
    );
  }, [configuration]);

  const isSwapEnabled = useMemo(() => {
    return !!configuration?.find?.(
      (config) => config?.typeId === 2 && config?.configuration?.length,
    );
  }, [configuration]);

  const checkTypeEnabledForOrder = useCallback(
    (typeId, passOrder) => {
      let seasonId, lineId;
      if (passOrder?.seasonId && passOrder?.customData?.lineId) {
        seasonId = passOrder.seasonId;
        lineId = passOrder.customData.lineId;
      } else if (order?.seasonId && order?.customData?.lineId) {
        seasonId = order.seasonId;
        lineId = order.customData.lineId;
      }
      if (!seasonId || !lineId) {
        if (typeId === 1) return isReorderEnabled;
        return isSwapEnabled;
      } else {
        return configuration?.find?.(
          (config) =>
            config?.typeId === typeId &&
            config?.configuration?.length &&
            config.configuration.some?.(
              (line) => line.lineID == lineId && line.seasonId == seasonId,
            ),
        );
      }
    },
    [
      configuration,
      isReorderEnabled,
      isSwapEnabled,
      order?.customData?.lineId,
      order?.seasonId,
    ],
  );

  return {
    isReorderEnabled,
    isSwapEnabled,
    isReorderEnabledForOrder: (passOrder) =>
      checkTypeEnabledForOrder(1, passOrder),
    isSwapEnabledForOrder: (passOrder) =>
      checkTypeEnabledForOrder(2, passOrder),
  };
};

export default useOrderType;
